module.exports = __webpack_public_path__ + "static/media/banner.36dbc487.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.jpg
// module id = 79
// module chunks = 0